<template>
	<div class="taskSearchTemplate">
		<el-dialog title="选择模板" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
			<el-table :data="tableData" highlight-current-row @current-change="templateChange" @row-dblclick="getTemplate" style="width: 100%" max-height="250">
				<el-table-column prop="NAME" label="模板名称" width="220">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="120">
					<template slot-scope="scope">
						<el-button @click.native.prevent="deleteRow(scope.$index, tableData,scope)" v-if="scope.row.USERID == cookieUser.userId" type="text" size="small">
							移除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
    			<el-button @click="dialogVisible = false">取 消</el-button>
    			<el-button type="primary" @click="getTemplate">确 定</el-button>
  			</span>
		</el-dialog>
	</div>
</template>

<script>
//	import { getToken } from "@/util/auth";
//	const cookieUser = getToken();
	import {
  		DelTaskSearchTemplate
	} from "@/api/modules/basicData/task";
	import {
		mapState,
		mapActions,
		mapMutations,
		mapGetters
	} from 'vuex'
	// import store from '@/store/modules/task'
	export default {
		name: "taskSearchTemplate",
		data() {
			return {
				dialogVisible: false,
				tableData: [],
				cookieUser:{},
				val:{}
			}
		},
		methods: {
			handleClose(done) {
				this.dialogVisible = false;
			},
			deleteRow(index, rows, scope) {
//				console.log(index,"index");
//				console.log(rows,"rows");
				// console.log(scope,"scope");
				DelTaskSearchTemplate(scope.row.ID, scope.row.USERID).then(res => {
					console.log(res)
				})
				rows.splice(index, 1);
			},
			getTemplate() {
				this.$store.commit('getTemplate');
				// this.$emit("searchTemplate")
			},
			templateChange(val) {
				console.log(val,"val")
				// this.val = val
				this.$store.state.task.value = val;
				console.log(this.$store.state.task.value,"this.$store.state.task.value")
		    },
		},
		// store
	}
</script>

<style scoped>

</style>